// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"with-dock-layout_wrapper__w0r7e","container":"with-dock-layout_container__2eC1h"};